import React from 'react';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import getStyles from './styles';

const faqs = [
  {
    question: '1. Who can apply for the Fellowship Program?',
    answer:
      'Any college student, fresher, or early career individual who is curious, ambitious, and willing to learn by doing.'
  },
  {
    question: '2. Do I need technical experience?',
    answer:
      'No. You only need hunger to learn and the ability to build and think independently.'
  },
  {
    question: '3. What is the duration of the fellowship?',
    answer:
      'The program runs for 90+ days, including discovery, bootcamp, and leadership immersion.'
  },
  {
    question: '4. What skills will I learn?',
    answer:
      'Leadership, problem solving, product thinking, communication, real-world project execution, teamwork, and decision-making.'
  },
  {
    question: '5. What makes this fellowship unique?',
    answer:
      'It focuses on real work, real problems, and real leadership — not theory or assignments.'
  }
];

const FAQSection = () => {
  const styles = getStyles();

  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Typography variant="h2" sx={styles.title}>
            Frequently Asked Questions
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            Everything you need to know about our Fellowship Program
          </Typography>
        </Box>

        {/* FAQ List */}
        <Box sx={styles.accordionContainer}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                ...styles.accordionItem,
                animationDelay: `${index * 0.1}s`
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
                sx={styles.accordionSummary}
              >
                <Typography sx={styles.question}>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                <Typography sx={styles.answer}>{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQSection;
